import React from 'react';
export const ModuleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-1-1h18v18H-1z" />
      <g transform="translate(.125 .125)">
        <circle cx="7.875" cy="7.875" r="7.875" fill="#161616" />
        <path
          fill="#FFF"
          d="M11.751 8.291l-5.349 3.566a.5.5 0 0 1-.777-.416V4.309a.5.5 0 0 1 .777-.416l5.349 3.566a.5.5 0 0 1 0 .832z"
        />
      </g>
    </g>
  </svg>
);
